import { v4 as uuid } from 'uuid';

export const groupBy = (data) => {
    const grouped = Object.entries(
        data.reduce((acc, pair) => {
            const key = pair.values[0].name; // group by first item's name
            if (!acc[key]) acc[key] = [];
            acc[key].push({ id: uuid(), values: pair.values, names: pair.names });
            return acc;
        }, {})
    ).map(([name, items]) => ({
        name,
        items
    }));
    return grouped;
}

export const groupByVariant = (data) => {
  const grouped = [];

  data.forEach((pair, index) => {
    const key = pair.values[0]?.name;

    const existingGroup = grouped.find(
      (item) => item.name === key
    );

    const formattedItem = {
      id: `${key}-${index}`,
      values: pair.values,
      names: pair.names,
      originalIndex: index,
    };

    if (existingGroup) {
      existingGroup.items.push(formattedItem);
    } else {
      grouped.push({
        name: key,
        items: [formattedItem],
      });
    }
  });

  return grouped;
};

export const generateCombinations = (variants, depth = 0, path = [], results = []) => {
    if (depth === variants.length) {
        results.push({
            values: path.map(v => { return { name: v.name, id: v.id } }),
            names: path.map(v => v.name).join(", "),
        }
        );
        return;
    }

    const current_variant = variants[depth];
    current_variant.option_values.forEach(value => {
        generateCombinations(variants, depth + 1, [...path, value], results);
    });

    return results;
}

export const getVariantOptions = (product_variants) => {
    const result = [];

    const attributeMap = new Map();

    for (const variant of product_variants) {
        for (const combination of variant.ProductVariantCombinations) {
            const attrId = combination.variant_attribute.id;
            const attrName = combination.variant_attribute.name;
            const valId = combination.variant_value.id;
            const valName = combination.variant_value.name;

            if (!attributeMap.has(attrId)) {
                attributeMap.set(attrId, {
                    option_name: attrName,
                    option_id: attrId,
                    option_values: new Map()
                });
            }

            const attr = attributeMap.get(attrId);
            attr.option_values.set(valId, { id: valId, name: valName });
        }
    }

    // Convert Maps to arrays
    for (const attr of attributeMap.values()) {
        result.push({
            id: uuid(),
            option_name: { id: attr.option_id, name: attr.option_name },
            option_values: Array.from(attr.option_values.values()),
            isNew: false,
        });
    }

    return result;
};

export const generateCombinationsPrices = (product_variants) => {
    let result = product_variants.map(variant => {
        return {
            buy_price: variant.buy_price,
            sell_price: variant.sell_price,
            stock_quantity: variant.stock_quantity,
            image_url: variant.image_url,
            variant_id: variant.id,
            variant_combination: variant.ProductVariantCombinations.map(combination => combination.variant_value.name).join(", "),
        };
    });

    return result;
}

export const formatProductVariants = (combinations, combination_values, fileMap = {}) => {
    let product_variants = [];
    combinations.forEach(group => {
        const groupName = group.name;
        const image_url = fileMap[groupName] || "";

        group.items.forEach(item => {
            const id = item.id;
            const variant_id = item.variant_id;
            const variant_values = item.values.map(v => v.id);

            product_variants.push({
                image_url,
                variant_values,
                buy_price: parseInt(combination_values[`buy_price_${id}`] ?? 0),
                sell_price: parseInt(combination_values[`sell_price_${id}`] ?? 0),
                stock_quantity: parseInt(combination_values[`stock_${id}`] ?? 0),
                id: variant_id,
            });
        });
    });
    return product_variants;
}

export const groupProductVariants = (product_variants) => {
  const grouped = [];

  product_variants.forEach((variant, index) => {
    const combinations = [...variant.ProductVariantCombinations]
      .sort((a, b) => a.display_order - b.display_order);

    const firstValue =
      combinations[0]?.variant_value?.name;

    const names = combinations
      .map((c) => c.variant_value.name)
      .join(", ");

    const item = {
      id: variant.id,
      names,
      values: combinations.map((c) => ({
        id: c.variant_value.id,
        name: c.variant_value.name,
      })),
      buy_price: variant.buy_price,
      sell_price: variant.sell_price,
      stock_quantity: variant.stock_quantity,
      stock_alert: variant.stock_alert,
      image_url: variant.image_url,
      variant_id: variant.id,
    };

    const existingGroup = grouped.find(
      (g) => g.name === firstValue
    );

    if (existingGroup) {
      existingGroup.items.push(item);
    } else {
      grouped.push({
        name: firstValue,
        items: [item],
      });
    }
  });

  return grouped;
};